import EATable from "../../EATable";
import React from "react";
import {createCalculatedColumn, createColumn, createComponentColumn} from "../../../utils/ColumnUtils";
import EABetriebsakteMainContainer from "../EABetriebsakteMainContainer";
import {createCustomTextLink} from "../../../utils/RouteUtils";
import {ANLAGE} from "../../../consts/fachobjekt";
import {useHistory} from "react-router-dom";
import {useHttp} from "../../../services/HttpService";
import {getKanalnetzUebersichtEndpoint} from "../../../services/AnlagenService";

export default function KanalnetzUebersicht(props) {
    const history = useHistory();
    const [{data, loading}] = useHttp(getKanalnetzUebersichtEndpoint(props.match.params.parentanlageid));

    const linkColumnComponentProvider = (row) => createCustomTextLink(row.bezeichnung, ANLAGE, row.id, history);

    const columns = [
        createComponentColumn("messstellenId", linkColumnComponentProvider, "Abwasseranlage"),
        createColumn("kanalsystem.value", "Kanalsystem"),
        createColumn("abwasserart.value", "Abwasserart"),
        createColumn("aufnahme.value", "Aufnehmende Anlage"),
        createCalculatedColumn(
            "betrieb.bezeichnung",
            (anlage) => anlage.betrieb.value,
            "Betrieb"
        ),
        createColumn("anlagenstatus.value", "Status")
    ];

    return (
        <div className={"viewScrollContainer"}>
            <EABetriebsakteMainContainer className={"tabsheet-content-margin"}>
                <EATable columns={columns} data={data} loading={loading}/>
            </EABetriebsakteMainContainer>
        </div>
    );
}
